<template>
    <el-row>
        <el-col :span="14">
            <div class="flexDirection" >
                <div class="logo" @click="goIndex()">
                    <img :src="logoUrl">
                </div>
                <!-- <div class="dividerLine"></div> -->
                <!-- <span class="slogan">{{headList.subtitle}}</span> -->
            </div>
        </el-col>
        <el-col :span="10">
            <div>
                <!-- 登陆后 -->
                <ul class="flexRow" style="height: 1rem;" v-if="LoginStatus">
                  <li style="margin-left: 0.40rem;" >
                    <span @click="openPrice()">费用标准</span>
                  </li>
                    <li style="margin-left: 0.40rem;" v-for="(item, index) of headList.List" :key="index">
                      <span @click="Jump(item.path)" v-if="item.title === '购物车'" class="numPosition">
                            <i class="iconfont icongouwuche" style="vertical-align: middle;"></i>
                            {{item.title}}
                            <span class="icon-car-count" v-if="user.shopping >0">{{user.shopping}}</span>
                        </span>
                      <span @click="Jump(item.path)" v-else>{{item.title}}</span>
                    </li>
                    <!-- <li style="margin-left: 0.1rem;"><span>APP下载</span></li> -->
<!--                    <li style="margin-left: 0.1rem;">
                        <el-popover
                            placement="bottom"
                            width="100"
                            trigger="hover">
                            &lt;!&ndash; <el-image
                                style="width: 100%"
                                :src="imgUrl"
                                :fit="fit">
                            </el-image> &ndash;&gt;
                            <div ref="qrCode" id="qrcode2" style="width: 100%"></div>
                            <span slot="reference">APP下载</span>
                        </el-popover>
                    </li>-->
                    <!-- <li style="margin-left: 0.1rem;"><span @click="jump('/knowledge/chat')">即时</span></li> -->
                    <li style="margin-left: 0.40rem;"><span @click="exit()">退出</span></li>
<!--                    <li style="margin-left: 0.1rem;color: #000"><span><a :href="homePage" style="color:#333;">总首页</a></span></li>-->
                </ul>
                <!-- 登陆前 -->
                <ul class="flexRow" v-else>
                  <li style="margin-left: 0.40rem;" >
                    <span @click="openPrice()">费用标准</span>
                  </li>
                    <li style="margin-left: 0.40rem;"><span @click="jump('/login')">登录</span></li>
                    <li style="margin-left: 0.40rem;"><span @click="jump('/login/register')">注册</span></li>

                    <!-- <li style="margin-left: 0.49rem;"><span>APP下载</span></li> -->
<!--                    <li style="margin-left: 0.49rem;">
                        <el-popover
                            placement="bottom"
                            width="100"
                            trigger="hover">
                            &lt;!&ndash; <el-image
                                style="width: 100%"
                                :src="imgUrl"
                                :fit="fit">
                            </el-image> &ndash;&gt;
                            <div ref="qrCode" id="qrcode2" style="width: 100%"></div>
                            <span slot="reference">APP下载</span>
                        </el-popover>
                    </li>-->
<!--                    <li style="margin-left: 0.49rem;"><span><a :href="homePage" style="color:#333;">总首页</a></span></li>-->
                </ul>
            </div>
        </el-col>

      <el-dialog title="费用标准" :visible.sync="dialogPriceVisible" width="50%" height="30%" z-index="999999">
        <div style="display: flex;align-items: center;">
          <img :src="feiyongUrl" style="max-width: 100%;max-height: 100%">
        </div>
      </el-dialog>
    </el-row>


</template>

<script>
import { mapState, mapGetters } from 'vuex'
import QRCode from 'qrcodejs2'
import { jump, getUser, removeUser, setUser} from '../../untils/auth'
export default {
    name: 'Header',
    data() {
        return {
            dialogPriceVisible: false,
            feiyongUrl:'',
            logoUrl:'',
            homePage: window.IPConfig.homePage,
            LoginStatus: '',
            active: '',
            imgUrl: '',
            fit: 'fill',
            VQrCodeImage: '',
            VQrCodeImageIos: '',
            headList: {
                imgUrl: require('../../assets/images/home.png'),
                logoCn: '',
                logoEn: '',
                subtitle: '知识成就未来',
                List: [
                   /* {
                        title: '购物车',
                        path: '/education/personalcenter/shopindex'
                    },
                    {
                        title: '我的消息',
                        path: '/education/personalcenter/message'
                    },
                    */
                    {
                        title: '用户中心',
                        path: '/education/personalcenter'
                    },

                ]
            }
        }
    },
    computed: {
        ...mapState([
            "user"
        ]),
        ...mapGetters([
            'addRouters'
        ])
    },

    methods: {
        i() {
            if (sessionStorage.getItem('exit')) {
                this.INIT()
            } else {
              if (this.$route.query.dandian || localStorage.getItem("dandian")) {
                    var loginForm = JSON.parse(this.$route.query.dandian || localStorage.getItem("dandian"));
                    this.axios.post(window.IPConfig.IP + '/LoginController/danlogin.do?userName=' + loginForm.userName + '&passWord=' + loginForm.passWord).then(response => {
                        if (response.data.status == 200) {
                            var roles = ['0']
                            // response.data.attributes.principal.VRoleName.forEach(item => {
                            response.data.attributes.principal.tbRoleVOList.forEach(item => {
                                if (item.VRoleName && item.VRoleName == '个人用户') {
                                    roles = ['0']
                                }
                                // if (item.VRoleName && item.VRoleName == '机构用户') {
                                //     roles.push('1')
                                // }
                            })
                            response.data.attributes.roles = roles
                            setUser(JSON.stringify(response.data.attributes))
                            this.$nextTick(() => {
                                this.INIT()
                            })
                        }
                    })
                } else {
                    this.INIT()
                }
            }
        },
        INIT() {
          this.LoginStatus = false;
          this.axios.post(window.IPConfig.IP + "/LoginController/queryLoginUser.do").then((response) => {
            console.log(response)
            if (response.status == 200) {
              if (response.data.status == 200) {
                this.loading = false;
                var roles = ['0']
                // response.data.attributes.principal.VRoleName.forEach(item => {
                response.data.attributes.principal.tbRoleVOList.forEach(item => {
                  if (item.VRoleName && item.VRoleName == '个人用户') {
                    roles = ['0']
                  }
                  // if (item.VRoleName && item.VRoleName == '机构用户') {
                  //     roles.push('1')
                  // }
                })
                response.data.attributes.roles = roles
                setUser(JSON.stringify(response.data.attributes))
                this.LoginStatus = true;
              }
            }

          });

            if (this.LoginStatus) {
              this.axios.post(window.IPConfig.IP + '/tBusShoppingcart/TBusShoppingcartShowInfo.do?VSystemId=' + this.$store.state.user.VSystemId+"&VIsExists=2").then(res => {
                console.log(res)
                if (res.data.status == 200) {
                  this.$store.dispatch('SetShopping', res.data.obj.length)
                }else if (res.data.status == 601) {
                  this.jump('/login')
                }
              })


                var length = 0
                this.axios.post(window.IPConfig.IP + '/tBusShoppingcart/TBusShoppingcartShowInfo.do?VSystemId=' + this.$store.state.user.VSystemId + '&VIsExists=1').then((response) => {
                    if (response.status == 200) {
                        if (response.data.obj) {
                          length = response.data.obj.length
                        }
                        this.axios.post(window.IPConfig.IP + '/tBusShoppingcart/TBusShoppingcartShowInfo.do?VSystemId=' + this.$store.state.user.VSystemId + '&VIsExists=2').then((response) => {
                            if (response.status == 200) {
                                  if (response.data.obj) {
                                    length += response.data.obj.length
                                    this.$store.dispatch('SetShopping', length)
                                  }
                            }
                        })
                            // this.$store.dispatch('SetShopping', response.data.obj.length)
                    }
                })
            }
            // this.axios.post(window.IPConfig.IP + '/tBSystemConfig/getById.do?Id=' + this.$store.state.user.VSystemId).then((response) =>{
            //     // console.log(response,'系统信息')
            //     if(response.status == 200){
            //         if(response.data.status == 200){
            //             this.VQrCodeImage = response.data.obj.VQrCodeImage
            //             this.VQrCodeImageIos = response.data.obj.VQrCodeImageIos
            //             this.SetImg()
            //         }
            //     }
            // })
            // 二维码
            this.axios.post(window.IPConfig.IP + '/tBAppVersion/queryPage.do?',{
                VSystemId: this.$store.state.user.VSystemId
            }).then((response) =>{
                if(response.status == 200){
                    if(response.data.status == 200){
                        // 获取二维码地址
                        // this.VQrCodeImage = response.data.obj.VQrCodeImage;
                        // this.VQrCodeImageIos = response.data.obj.VQrCodeImageIos;
                        let qrCodes = response.data.obj.records;
                        if(qrCodes.length){
                            qrCodes.forEach(item => {
                                if(item.TContent){
                                    if(item.TContent.indexOf('安卓') != -1){
                                        this.VQrCodeImage = item.TAddress;
                                    }else{
                                        this.VQrCodeImageIos = item.TAddress;
                                    }
                                }
                            })
                        }
                        this.SetImg()
                        //this.VQrCodeImage = response.data.obj.VSystemUrl;
                        //this.VQrCodeImageIos = response.data.obj.VSystemUrl;

                    }
                }
            })
        },
        SetImg() {
            let _this = this;
            var agent = navigator.userAgent.toLowerCase();
            var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
            if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0 || agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
                //your code
                this.imgUrl = this.VQrCodeImage
                // alert("这是windows32位系统");
            }
            if(isMac){
                //your code
                this.imgUrl = this.VQrCodeImageIos
                // alert("这是mac系统");
            }
            // 生成二维码
            this.$nextTick(() => {
                _this.crateQrcode()
            })
        },
        // 生成二维码
        crateQrcode () {
            // this.$refs['qrCode'].innerHTML = '';
            this.qr = new QRCode('qrcode2', {
                width: 100,
                height: 100, // 高度
                text: this.imgUrl // 二维码内容
                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f'
                // foreground: '#ff0'
            });
        },
        jump,
        // 清除用户信息
        removeUser,
        // 退出登录
        exit(){
            this.axios.post(window.IPConfig.IP + '/LoginController/admin/logout').then((response) => {
                if(response.status == 200){
                    if(response.data.status == 200){
                        // 清除用户信息
                        this.removeUser();
                        sessionStorage.setItem('exit', '1')
                        window.location.reload();
                        localStorage.removeItem('dandian')

                    }
                }
            })
        },
        Jump(path) {
            if (!path) {
                this.$message({
                    message: '请先选择子系统',
                    type: 'error',
                    center: true
                });
            } else {
                this.jump(path)
            }
        },

      goIndex(){
        this.$router.push({ path: "index", force: true });
        setTimeout(() => {
          window.location.reload();
        }, 0);
      },


      openPrice(){
        this.dialogPriceVisible = true;
      },
    },
    watch: {
        $route(newVal, oldVal) {
            this.i()
        }
    },
    created() {


      /*配置表*/
      this.axios
        .post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=logo").then((res) => {
        if (res.status == 200) {
          console.log(res)
          if (res.data.status == 200) {
            this.logoUrl =res.data.url+res.data.obj[0].VLine;
          }
        }
      });

      /*配置表*/
      this.axios
        .post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=feiyong").then((res) => {
        if (res.status == 200) {
          if (res.data.status == 200) {
            this.feiyongUrl = res.data.url + res.data.obj[0].VLine;
          }
        }
      });

      this.i();


    },
}
</script>

<style>
  .el-dialog{
    margin-top: 20px !important;
  }

    /* logo */
    .flexDirection {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .flexDirection .logo {
        width: 4.17rem;
        height: 1rem;
        padding: 0.11rem 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }
    .flexDirection .logo img {
        /* width: 0.89rem; */
        height: .6rem;
    }
    .flexDirection .logo .logoTextBox {
        width: 3.39rem;
        height: 0.46rem;
        padding-left: 0.2rem;
        line-height: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .flexDirection .logo .logoTextBox .logoCn {
        font-size: 0.28rem;
    }
    .flexDirection .logo .logoTextBox .logoEn {
        font-size: 0.16rem;
        color: #c0c0c0;
    }
    .flexDirection .dividerLine {
        width: 0.01rem;
        height: 0.48rem;
        background: rgba(0, 0, 0, 1);
        opacity: 0.2;
        margin: 0.26rem 0
    }
    .flexDirection .slogan {
        width: 1.8rem;
        height: 0.29rem;
        font-size: 0.3rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 0.27rem;
        margin: 0.36rem 0;
    }
    /* 右上角 */
    .fullDiv {
        width: 100%;
        /*height: 0.6rem;*/
        /*background: #228457;*/
        /*padding: 0.6rem;*/
        /*background: url("../../assets/images/changtiao.jpg") right no-repeat;*/
      background-image: url("../../assets/images/changtiao.jpg");
      background-position: right;
      background-repeat: no-repeat;
    }
    .flexRow {
        display: flex;
        flex-direction: row;
        justify-content: end;
        align-items: end;
      -webkit-box-pack: end !important;
      -ms-flex-pack: end !important;
      justify-content: end !important;
    }
    .flexRow li {
        height: 100%;
        font-size: 0.18rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 1rem;
    }
    .flexRow li span {
        cursor: pointer;
    }
    .flexRow li .numPosition {
        position: relative;
    }
    .flexRow li .numPosition .icon-car-count {
        min-width: 0.14rem;
        text-align: center;
        line-height: 0.14rem;
        display: inline-block;
        position: absolute;
        right: 0.5rem;
        top: -0.12rem;
        background: red;
        color: #fff;
        border-radius: 50%;
        padding: 0.06rem;
        font-size: 0.16rem;
        transform: scale(.7);
        font-family: 'Tahoma' !important;
    }
    .flexRow li.navLi {
        width: 1.8rem;
        height: 0.6rem;
        line-height: 0.6rem;
        /*background: #228457;*/
        text-align: center;
        color: black;
        font-size: 0.22rem;
        cursor: pointer;
        margin-left: 0px;
    }
    #qrcode2 img{
        margin: 0 auto;
        width: 1rem;
        height: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/ivew/header.vue